import styled from 'styled-components';
import Theme from './Theme';
export function textMuted() {
  return "\n    color: ".concat(Theme.textMutedColour, ";\n  ");
}
export function ellipsis() {
  return "\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  ";
}
export var withStyles = function withStyles() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return function (Component) {
    return styled(Component).withConfig({
      displayName: "Styles",
      componentId: "sc-1jqy1nr-0"
    }).apply(void 0, args);
  };
};